// Espelha src/shared/enums/AdminPermissionEnum.ts do backend (brcomerce-api).
// Mantenha os valores em sincronia com o backend.
const AdminPermissionEnum = {
  // Acesso total (admin nivel 1). Bypassa todas as checagens e e o unico que
  // pode gerenciar usuarios admin.
  SUPER_ADMIN: "super_admin",
  // Acesso a tudo que envolve valores/financeiro: faturamento, valores de rota,
  // politica de preco, conciliacao, relatorios e dashboard financeiro.
  VIEW_FINANCIAL: "view_financial",
};

// Rotulos em pt-BR para exibir no editor de permissoes do formulario de usuario.
export const AdminPermissionLabels = {
  [AdminPermissionEnum.SUPER_ADMIN]: "Acesso total",
  [AdminPermissionEnum.VIEW_FINANCIAL]: "Acesso financeiro",
};

export default Object.freeze({
  ...AdminPermissionEnum,
});
